export const userTypes = {
	ADMIN: 'Admin',
	INSTITUTION: 'Institution',
	USER: 'User',
};

export const CourseStatusColors = {
	PASSED: '#1DAA6C',
	FINISHED: '#ff9900', // Finished but not passed
	STARTED: '#1aa3ff',
	NOT_STARTED: '#999999',
};

export const CourseStatus = {
	PASSED: 'COMPLETADO',
	FINISHED: 'TERMINADO',
	STARTED: 'COMENZADO',
	NOT_STARTED: 'SIN COMENZAR',
};
